<template><div><h1>VUX V2.5.6 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[fix] Fix json parsing issue for cancel menu #1782</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] Support event:on-shadow-change #1778</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Support event:on-shadow-change #1778</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] Fix is-type validating logic #1776</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.6-119.vue?3869a3aa